<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1" name="settingsTitle">{{ t('userProfile.editUserProfile') }}</h1>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content [class.container]="false" [class.px-gutter]="true" class="-mt-6">
			<div class="card overflow-auto -mt-16">
				<div @fadeInUp @stagger class="mb-4">
					<vex-update-profile
						(allowUpdate)="setAllowUpdateProfile($event)"
						(formChanged)="setChangedProfile($event)"
						[isEdit]="isEdit()"
						[update]="updateProfile"></vex-update-profile>
					<vex-update-mail
						(allowUpdate)="setAllowUpdateEmail($event)"
						(formChanged)="setChangedEmail($event)"
						[isEdit]="isEdit()"
						[update]="updateEmail"></vex-update-mail>
					<div class="px-12 flex flex-row justify-end items-center">
						<div>
							@if (isEdit()) {
								<button class="m-2" mat-raised-button (click)="cancel()">
									<mat-icon>cancel</mat-icon>
									<span>
										{{ t('commonActions.cancel') }}
									</span>
								</button>
								<button class="m-2" mat-raised-button color="primary" [disabled]="!allowUpdate() || !formChanged()" (click)="save()">
									<mat-icon>save</mat-icon>
									<span>
										{{ t('commonActions.save') }}
									</span>
								</button>
							} @else {
								<button class="m-2" mat-raised-button color="primary" (click)="edit()">
									<mat-icon>edit</mat-icon>
									<span>
										{{ t('commonActions.edit') }}
									</span>
								</button>
							}
						</div>
					</div>
					<vex-update-password></vex-update-password>
					<vex-delete-profile></vex-delete-profile>
				</div>
			</div>
		</vex-page-layout-content>
	</vex-page-layout>
</div>
